export default __webpack_public_path__ + "static/media/compare_arrows.f94abc7d.svg";